<div class="row w-100 vr-header mx-0 justify-content-center mt-5 border-2 px-md-5 px-3">
  <div></div>
  <div class="col-12 col-md-7 vr-header-left mx-0 my-auto mb-0 mb-md-auto order-1">
    <div class="vr-bg-image"></div>
    <div class="vr-header-cotent pt-5 pb-3 pb-md-5">
      <div class="title">
        {{ "Interview Training with AI" | translate }}
      </div>
      <div class="description mt-2">
        {{ "Be more professional in your interview with our modern AI trainee." | translate }}
      </div>
      <div class="mt-4">
        <button class="gradient-button" (click)="goToVirtualSteps()">
          {{ "Get Start Now" | translate }}
        </button>
        <button class="border-button" (click)="goToVirtualSteps()">
          {{ "View your tries" | translate }}
        </button>
      </div>
    </div>
  </div>
  <img
    class="col-12 col-md-5 text-center p-0 order-2"
    src="assets/img/virtual-interview.png"
  />
</div>
<app-video-tutorial
  [title]="'virtualInterview.videoTitle'"
  [buttonText]="'virtualInterview.videoButton'"
  (buttonClicked)="goToVirtualSteps()"
  [videoPath]="'assets/video/Interview_1.mp4'"
  [videoPoster]="'assets/img/virtual-interview.png'"
  [features]="[
    'virtualInterview.feature1',
    'virtualInterview.feature2',
    'virtualInterview.feature3'
  ]">
</app-video-tutorial>
<!-- Services Section -->
<section class="services-section">
  <div class="container">
    <div class="row justify-content-center px-md-0 px-3">
      <!-- Title Card -->
      <div class="col-12 col-sm-6 col-md-4">
        <div class="title-card">
          <h3 class="services-main-title">
            {{ "Use AI to be more professional in your interview with UpCareer" | translate }}
          </h3>
          <p class="services-main-description">
            {{ "Up-Career will help you to find your dream job in few steps" | translate }}
          </p>
        </div>
      </div>

      <!-- Service Cards -->
      <app-card
        *ngFor="let item of services"
        [color]="item.color"
        [img]="item.img"
        [title]="item.title | translate"
        [description]="item.description | translate"
      />
    </div>
  </div>
</section>

<!-- Virtual Interview Training Circle Steps -->
<section class="vr-steps container-fluid my-5 my-md-0 mt-4">
  <div class="row row-cols-3 gx-0 gx-md-3">
    <div class="col">
      <div class="card">
        <p class="step-number">01</p>
        <div class="circle-card">
          <span class="circle-step-number">01</span>
          <p>{{ "vi.steps.step1" | translate }}</p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="card">
        <p class="step-number">02</p>
        <div class="circle-card">
          <span class="circle-step-number">02</span>
          <p>{{ "vi.steps.step2" | translate }}</p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="card">
        <p class="step-number">03</p>
        <div class="circle-card">
          <span class="circle-step-number">03</span>
          <p>{{ "vi.steps.step3" | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</section>